var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.role == 3 || _vm.role == 4),expression:"role == 3 || role == 4"}]},[_c('img',{staticClass:"sm:mr-6 mr-2",staticStyle:{"width":"27px","cursor":"pointer"},attrs:{"src":require("@/assets/images/inbox/inbox.svg"),"alt":"icon inbox"},on:{"click":_vm.routeInbox}})])
}
var staticRenderFns = []

export { render, staticRenderFns }